// Mobile menu
function toggleMenu() {
  var menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

document.addEventListener('click', function(e) {
  var menu = document.getElementById('mobileMenu');
  var toggle = document.querySelector('.header__menu-toggle');
  if (menu && toggle && !menu.contains(e.target) && !toggle.contains(e.target)) {
    menu.classList.remove('open');
  }
});

// Custom cursor
(function () {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var dot = document.createElement('div');
  dot.className = 'cursor-dot';
  var ring = document.createElement('div');
  ring.className = 'cursor-ring';
  document.body.appendChild(dot);
  document.body.appendChild(ring);

  var mx = -200, my = -200, rx = -200, ry = -200;

  document.addEventListener('mousemove', function (e) {
    mx = e.clientX;
    my = e.clientY;
    dot.style.left = mx + 'px';
    dot.style.top  = my + 'px';
    dot.classList.remove('cursor-dot--hidden');
    ring.classList.remove('cursor-ring--hidden');
  });

  document.addEventListener('mouseleave', function () {
    dot.classList.add('cursor-dot--hidden');
    ring.classList.add('cursor-ring--hidden');
  });

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest('a, button, [role="button"], input, select, textarea, label')) {
      ring.classList.add('cursor-ring--hover');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('a, button, [role="button"], input, select, textarea, label')) {
      ring.classList.remove('cursor-ring--hover');
    }
  });

  (function animateRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    ring.style.left = rx + 'px';
    ring.style.top  = ry + 'px';
    requestAnimationFrame(animateRing);
  })();
})();

// Scroll reveal
if (typeof IntersectionObserver !== 'undefined') {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.collection-section, .about-section, .promo-bar').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    observer.observe(el);
  });
}
